export const isValidRouteParam = (value: string | null | undefined): value is string =>
  !!value && value !== 'undefined' && value !== 'null';
